import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import React, { useState } from "react";
import Chip from "@material-ui/core/Chip";
import { useSelector } from "react-redux";

import ConditionalTooltip from "../../../ConditionalTooltip";
import * as constants from "../../../../constants";
import Button from "@material-ui/core/Button";
import PropertiesSearchDialog from "../../PropertiesSearch";

const General = ({ formik, admin, disabled }) => {
  const [showPropertiesSearch, setShowPropertiesSearch] = useState(false);
  const properties = useSelector((state) => state.properties.byId);
  const classes = useStyles();
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h5">General</Typography>
          <div className={classes.separator} />
          <Divider />
        </Grid>
        <ConditionalTooltip
          title={constants.helpText.adminOnlyEdit}
          visible={!admin && !disabled}
        >
          <Grid item xs={12} sm={4}>
            <TextField
              value={formik.values.firstName}
              onChange={formik.handleChange}
              disabled={!admin || disabled}
              error={formik.errors.firstName}
              fullWidth
              helperText={formik.errors.firstName}
              label="First Name"
              name="firstName"
              onBlur={formik.handleBlur}
              variant="filled"
            />
          </Grid>
        </ConditionalTooltip>
        <ConditionalTooltip
          title={constants.helpText.adminOnlyEdit}
          visible={!admin && !disabled}
        >
          <Grid item xs={12} sm={4}>
            <TextField
              value={formik.values.lastName}
              onChange={formik.handleChange}
              disabled={!admin || disabled}
              error={formik.errors.lastName}
              fullWidth
              helperText={formik.errors.lastName}
              label="Last Name"
              name="lastName"
              onBlur={formik.handleBlur}
              variant="filled"
            />
          </Grid>
        </ConditionalTooltip>
        <ConditionalTooltip
          title={constants.helpText.readOnly}
          visible={!disabled}
        >
          <Grid item xs={12} sm={4}>
            <TextField
              value={formik.values.email}
              disabled
              fullWidth
              label="Email"
              variant="filled"
            />
          </Grid>
        </ConditionalTooltip>
        <Grid item xs={12}>
          <Typography>Properties</Typography>
        </Grid>
        <Grid item xs={12}>
          {formik.values.propertyIds.map((propertyId) => {
            return (
              <Chip
                className={classes.chip}
                key={propertyId}
                label={properties[propertyId].displayName}
                onDelete={() =>
                  formik.setFieldValue(
                    "propertyIds",
                    formik.values.propertyIds.filter((id) => id !== propertyId)
                  )
                }
              />
            );
          })}
          <Button color="primary" onClick={() => setShowPropertiesSearch(true)}>
            Add
          </Button>
        </Grid>
      </Grid>
      {showPropertiesSearch && (
        <PropertiesSearchDialog
          onPropertyClick={(propertyId) =>
            formik.setFieldValue("propertyIds", [
              ...formik.values.propertyIds,
              propertyId,
            ])
          }
          open={showPropertiesSearch}
          onClose={() => setShowPropertiesSearch(false)}
        />
      )}
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  verticallyCentered: {
    height: "100%",
    display: "flex",
    alignItems: "center",
  },
  separator: {
    height: 8,
  },
  chip: {
    margin: theme.spacing(1),
  },
}));

export default General;
